export default "__VITE_ASSET__O2lOjmCz__"